// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Form_checkbox__236ZS"};